import { BankDetailsFragment, BankType } from "@generated/graphql";

export const isDomesticBankValid = (details: BankDetailsFragment): boolean =>
    details.bank_type === BankType.DOMESTIC &&
    Boolean(details.account_name && details.bsb && details.account_number);

export const isOverseasBankValid = (details: BankDetailsFragment): boolean =>
    details.bank_type === BankType.OVERSEAS &&
    Boolean(details.account_name && details.swift && details.iban && details.branch_address);

const bankValidationMap: { [key in BankType]?: (details: BankDetailsFragment) => boolean } = {
    [BankType.DOMESTIC]: isDomesticBankValid,
    [BankType.OVERSEAS]: isOverseasBankValid,
};

export const isBankDetailsValid = (details: BankDetailsFragment): boolean =>
    details.bank_type ? bankValidationMap[details.bank_type]?.(details) ?? false : false;

